import { TextTypes } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ICustomerInvestedAssetsNormalized } from '../../../../../../../store/customerDetail/types';

import { ProductDistributionHeaderDesktop } from './Desktop';
import { ProductDistributionHeaderMobile } from './Mobile';

export namespace ProductDistributionHeaderTypes {
  export interface Props {
    hasError: boolean;
    isLoading: boolean;
    totalValue: number;
    products: ICustomerInvestedAssetsNormalized['assetsNormalized'];
    isToday?: boolean;
    isExportingPdf?: boolean;
    selectedDate?: Date;
    onDownloadPdf?: () => void;
    onSendToClient?: () => void;
    onDateSelected?: (date?: Date | undefined) => void;
    hasDateFilter?: boolean;
    hasPdfExport?: boolean;
    principalTitle?: string;
    principalTitleProps?: TextTypes.Props;
  }
}

export const ProductDistributionHeader: React.FC<ProductDistributionHeaderTypes.Props> = (
  props
) => {
  const content = useBreakpointValue({
    base: <ProductDistributionHeaderMobile {...props} />,
    sm: <ProductDistributionHeaderDesktop {...props} />,
    lg: <ProductDistributionHeaderDesktop {...props} />,
  });

  return content;
};
